var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxFontColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54102 13.2487H13.4577V15.3737H3.54102V13.2487ZM8.85352 3.33203H8.14518C7.86114 3.33203 7.60402 3.50203 7.49281 3.76341L4.06872 11.832H5.60793L6.50964 9.70703H10.4791L11.3773 11.832H12.9151L9.50589 3.76411C9.45162 3.63597 9.3608 3.52666 9.24478 3.44981C9.12876 3.37297 8.99268 3.33201 8.85352 3.33203ZM7.11102 8.29036L8.49864 5.0207L9.8806 8.29036H7.11102Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxFontColor);
export default __webpack_public_path__ + "static/media/bx-font-color.14c81835338e23bd2e583fa587239dd1.svg";
export { ForwardRef as ReactComponent };